import { emptyPackagingProductFilters, UNKNOWN_MAIN_GROUP, UNSPECIFIED_SUB_GROUP, UNSPECIFIED_SUBDIVISION,
  type PackagingProductFilters, type packagingProductFilterOptions } from "./packaging-product-catalog";

type Props = {
  value: PackagingProductFilters;
  options: ReturnType<typeof packagingProductFilterOptions>;
  onChange: (value: PackagingProductFilters) => void;
};

export function PackagingProductFilterControls({ value, options, onChange }: Props) {
  const mainGroups = options.mainGroups.filter((group) => group !== UNKNOWN_MAIN_GROUP);
  const subGroups = options.subGroups.filter((group) => group !== UNSPECIFIED_SUB_GROUP);
  const subdivisions = options.subdivisions.filter((group) => group !== UNSPECIFIED_SUBDIVISION);
  const showSubGroup = Boolean(value.mainGroup) && subGroups.length > 0;
  const showSubdivision = showSubGroup && Boolean(value.subGroup) && subdivisions.length > 0;
  return <fieldset className="pack39-product-filter"><legend className="pack39-sr-only">Ürün sınıflaması</legend>
    <div className="pack39-product-filter-controls">
      <label><span>Ürün grubu</span><select value={value.mainGroup} data-filter-active={Boolean(value.mainGroup)}
        onChange={(event) => onChange({ mainGroup: event.target.value, subGroup: "", subdivision: "" })}>
        <option value="">Tüm gruplar</option>{mainGroups.map((group) => <option key={group} value={group}>{group}</option>)}
      </select></label>
      {showSubGroup ? <label><span>Alt grup</span><select value={value.subGroup} data-filter-active={Boolean(value.subGroup)}
        onChange={(event) => onChange({ ...value, subGroup: event.target.value, subdivision: "" })}>
        <option value="">Tüm alt gruplar</option>{subGroups.map((group) => <option key={group} value={group}>{group}</option>)}
      </select></label> : null}
      {showSubdivision ? <label><span>Alt kırılım</span><select value={value.subdivision} data-filter-active={Boolean(value.subdivision)}
        onChange={(event) => onChange({ ...value, subdivision: event.target.value })}>
        <option value="">Tüm alt kırılımlar</option>{subdivisions.map((group) => <option key={group} value={group}>{group}</option>)}
      </select></label> : null}
      {value.mainGroup ? <button type="button" className="pack39-product-filter-reset" onClick={() => onChange(emptyPackagingProductFilters())}
        aria-label="Ürün grubu filtrelerini temizle">Temizle</button> : null}
    </div>
  </fieldset>;
}
